import AttendAllowanceFormAdd from './AttendAllowanceFormAdd';

export default AttendAllowanceFormAdd;
